import { render, staticRenderFns } from "./risks.vue?vue&type=template&id=a5dd4314&scoped=true"
import script from "./risks.vue?vue&type=script&lang=js"
export * from "./risks.vue?vue&type=script&lang=js"
import style0 from "./risks.vue?vue&type=style&index=0&id=a5dd4314&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5dd4314",
  null
  
)

export default component.exports